<template>
    <div id="app">
        <map-layer/>
        <div class="footer">
            <router-view />
            <dock v-bind:class="{'dock-slide': hideDock }" />
        </div>
    </div>
</template>

<script>
import { Icon } from 'leaflet'
import MapLayer from '@/components/map/MapLayer'
import Dock from '@/components/controls/Dock'
import { mapGetters, mapActions } from 'vuex'
import 'leaflet/dist/leaflet.css'
// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl
// todo smarter hiding and showing dock
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
export default {
  name: 'Main',
  props: ['test'],
  components: { MapLayer, Dock },
  computed: {
    ...mapGetters([
      'hideDock'
    ])
  },
  methods: {
    ...mapActions(['getObjects', 'getGroups'])
  },
  created () {
    this.getObjects().then(resp => {
      console.log(resp)
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue